import * as _ from "lodash-es";
import React, { ChangeEvent, Component, MouseEventHandler } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, MessageDescriptor, useIntl } from "react-intl";
import { NavLink } from "react-router-dom";
import IConnection_Token from "../../../models/IConnection_Token";
import INavItem from "../../../models/INavItem";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IUserTypeAccessDetail from "../../../models/IUserTypeAccessDetail";
import UserTypesEnum from "../../../models/UserTypesEnum";
import ViewAccessService from "../../../services/ViewAccessService";
import BetaBadge from "../BetaBadge/BetaBadge";
import OwLabel from "../OwLabel/OwLabel";
import OwTranslate from "../OwTranslate/OwTranslate";
import "./SideNavLink.scss";

type Props = {
    user?: IUserUI;
    isSupplierUser: boolean;
    supplierUserToken?: IConnection_Token;
    vendorUserToken?: IConnection_Token;
    navItem: INavItem;
    navigated: any;
    menuIconMode: boolean;
    toggleEditMode?: () => void;
};

export const SideNavLink: React.FC<Props> = (props) => {
    const intl = useIntl();

    const onClick = (section: any) => {
        // console.log("Nav Link Clicked...");
        if (!_.isNil(section.selectable) && !section.selectable) {
            return null;
        } else {
            // console.log("navigated...");
            props.navigated();
        }
    };

    const getNavSubItems = () => {
        if (!props.navItem.sections) {
            return null;
        } else {
            const navSubItems = _.map(props.navItem.sections, (section, index) => {
                const descriptor: MessageDescriptor = {
                    description: section.title,
                    id: section.title,
                    defaultMessage: section.title,
                };

                return (
                    <li key={index} className={!section.selectable ? "not-selectable" : ""} title={intl.formatMessage(descriptor)}>
                        <NavLink
                            id={section.title}
                            title={section.ariaLabel}
                            end={section.exact}
                            to={section.pathFn ? section.pathFn() : section.path}
                            onClick={(e: any) => {
                                onClick(section);
                            }}>
                            <i className={section.icon + " me-2 ms-2 "} />
                            {props.menuIconMode ? null : <OwLabel title={section.title} noBottomMargin={true} />}
                            {section.isBeta ? <BetaBadge /> : ""}
                        </NavLink>
                    </li>
                );
            });

            return <ul className={"list-unstyled navSubItems " + (props.menuIconMode ? "menuIconMode" : "")}>{navSubItems}</ul>;
        }
    };

    const hasAccess = (): boolean => {
        return ViewAccessService.hasAccess(
            props.navItem,
            props.isSupplierUser,
            props.user?.supplierUserToken,
            props.user?.vendorUserToken,
            props.user?.isVendorSourceUser
        );
    };

    const { navItem, user } = props;

    const userTypeId = _.get(user, "userType.id", 999);

    // Check before rendering to see if the user has access to the particular section.
    if (!hasAccess()) {
        return null;
    }

    const navSubItems = getNavSubItems();

    let hasNavSubItems = false;

    if (navSubItems) {
        hasNavSubItems = true;
    }

    let fragment: any;

    const descriptor: MessageDescriptor = {
        description: navItem.title,
        id: navItem.title,
        defaultMessage: navItem.title,
    };

    const handleEdit = (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        if (props.toggleEditMode) {
            props.toggleEditMode();
        }
    };

    if (props.navItem.selectable === false) {
        fragment = (
            <React.Fragment>
                <li className={"no-pointer " + (hasNavSubItems ? "hasSections notSelectable" : "")} title={intl.formatMessage(descriptor)}>
                    <i className={navItem.icon + " me-2"} />
                    {props.menuIconMode ? null : <OwLabel title={navItem.title} noBottomMargin={true} />}
                    {navItem.isBeta ? <BetaBadge /> : ""}
                </li>
                {/*hasNavSubItems && props.menuIconMode? <div className={'subNavLine'}></div> : null*/}
                {hasNavSubItems && props.menuIconMode ? (
                    <div className={"subNavStart"}>
                        <i className={"far fa-chevron-down fa-xs"}></i>
                    </div>
                ) : null}
                {navSubItems}
                {hasNavSubItems && props.menuIconMode ? <div className={"subNavLine"}></div> : null}
            </React.Fragment>
        );
    } else {
        fragment = (
            <React.Fragment>
                <NavLink
                    id={navItem.title}
                    end={navItem.exact}
                    to={navItem.pathFn ? navItem.pathFn() : navItem.path}
                    onClick={(e: any) => {
                        onClick(navItem);
                    }}>
                    <li className={" " + (hasNavSubItems ? "hasSections" : "")} title={intl.formatMessage(descriptor)}>
                        <div className={"d-inline-flex w-100 align-items-center"}>
                            <i className={navItem.icon + " me-2"} />
                            {props.menuIconMode ? null : <OwLabel title={navItem.title} noBottomMargin={true} />}
                            {navItem.isBeta ? <BetaBadge /> : ""}
                            {/*<i onClick={handleEdit} className={"editPencil fas fa-pencil text-muted ms-auto me-2"}></i>*/}
                        </div>
                    </li>
                </NavLink>
                {hasNavSubItems && props.menuIconMode ? (
                    <div className={"subNavStart"}>
                        <i className={"far fa-chevron-down fa-xs"}></i>
                    </div>
                ) : null}
                {navSubItems}
                {hasNavSubItems && props.menuIconMode ? <div className={"subNavLine"}></div> : null}
            </React.Fragment>
        );
    }

    return fragment;
};
